import React from 'react';
import {useStyles} from "./MiscellanySalePrices.style";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { useCommonContext } from '../../../../contexts/CommonContext';
import { useI18nContext } from '../../../../contexts/I18nContext';
import MiscellanySalePriceStore from './MiscellanySalePriceStore';
import { Observer } from 'mobx-react-lite';
import MiscellanySalePriceRow from './MiscellanySalePricesRow/MiscellanySalePriceRow';
import MessageCard from '../../../../ui_components/MessageCard/MessageCard';
import MiscellanySalePricesProperties from './MiscellanySalePricesProperties';
import CopyServicePricesButton from '../../../../shared_components/Buttons/CopyServicePricesButton/CopyServicePricesButton';
import SalePriceItemType from '../../../../entities/SalePriceItemType';
import ButtonSize from '../../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../../ui_components/Button/ButtonType';


const MiscellanySalePrices: React.FC<MiscellanySalePricesProperties> = ({
    salePrice,
    onUpdate = () => {
    },
}) => {
    const commonStore = useCommonContext();
    const i18n = useI18nContext();
    const store = new MiscellanySalePriceStore(commonStore);
    const classes = useStyles();

    store.getMiscellanyCategory();

    return (
        <Observer>
            {() => (
                <div className={classes.miscellany_sale_prices_container}>
                    <div className={classes.new_button_container}>
                        <CopyServicePricesButton
                            size={ButtonSize.SMALL}
                            onSave={onUpdate}
                            showText
                            sourceSalePriceId={salePrice?.id ?? ''}
                            serviceName={SalePriceItemType.MISCELLANY}
                            type={ButtonType.SECONDARY}
                        />
                    </div>
                    {!store.isEmpty &&
                    <div className={classes.miscellany_sale_prices_table}>
                        <div className={classes.elements_container}>
                            {store.miscellanyCategories.map((miscellanyCategory, i) => (
                                <MiscellanySalePriceRow
                                    onUpdate={onUpdate}
                                    miscellanyCategory={miscellanyCategory}
                                    salePrice={salePrice}
                                    key={i}
                                />
                            ))}
                        </div>
                    </div>}
                    {store.isEmpty &&
                    <MessageCard icon={CurrencyExchangeIcon} title={i18n.translate("NO_MONEY_SERVICE_FEE_TITLE")}
                                 subtitle={i18n.translate("NO_MONEY_SERVICE_FEE_SUBTITLE")}/>}
                </div>
            )}
        </Observer>
    )
}

export default MiscellanySalePrices;
